import React, { useState } from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalContent,
  ProjectList,
  ProjectItem,
  ProjectIcon,
  ProjectInfo,
  ProjectName,
  ProjectId,
  CheckIcon,
  EmptyState,
  SearchBox
} from './styles';
import { IoClose, IoCheckmarkCircle, IoBusinessOutline, IoSearchOutline, IoCubeOutline } from 'react-icons/io5';

const ProjectSelectorModal = ({ isOpen, onClose, projects = [], currentProjectId, onSelectProject, loading = false }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!isOpen) return null;

  const filteredProjects = projects.filter(project => {
    const searchLower = searchTerm.toLowerCase();
    return (
      project.nome?.toLowerCase().includes(searchLower) ||
      project.id?.toLowerCase().includes(searchLower) ||
      project.cnpj?.includes(searchTerm)
    );
  });

  const handleProjectClick = (projectId) => {
    // Se for o mesmo projeto, apenas fecha o modal
    if (projectId === currentProjectId) {
      onClose();
      return;
    }

    // Salva o novo projeto e recarrega a página
    localStorage.setItem('vidal_selected_project', projectId);
    window.location.reload();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>
            <IoBusinessOutline />
            Selecionar Projeto
          </ModalTitle>
          <CloseButton onClick={onClose}>
            <IoClose />
          </CloseButton>
        </ModalHeader>

        <SearchBox>
          <IoSearchOutline className="search-icon" />
          <input
            type="text"
            placeholder="Buscar por nome, ID ou CNPJ..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SearchBox>

        <ModalContent>
          {loading ? (
            <EmptyState>
              <IoBusinessOutline />
              <p>Carregando projetos...</p>
              <span>Aguarde um momento</span>
            </EmptyState>
          ) : filteredProjects.length === 0 ? (
            <EmptyState>
              <IoBusinessOutline />
              <p>Nenhum projeto encontrado</p>
              <span>Tente ajustar sua busca</span>
            </EmptyState>
          ) : (
            <ProjectList>
              {filteredProjects.map((project) => (
                <ProjectItem
                  key={project.id}
                  isActive={project.id === currentProjectId}
                  onClick={() => handleProjectClick(project.id)}
                >
                  <ProjectIcon isActive={project.id === currentProjectId} color={project.color}>
                    <IoCubeOutline />
                  </ProjectIcon>
                  <ProjectInfo>
                    <ProjectName>{project.nome || 'Projeto sem nome'}</ProjectName>
                    <ProjectId>
                      {project.cnpj ? `CNPJ: ${project.cnpj}` : `ID: ${project.id}`}
                    </ProjectId>
                  </ProjectInfo>
                  {project.id === currentProjectId && (
                    <CheckIcon>
                      <IoCheckmarkCircle />
                    </CheckIcon>
                  )}
                </ProjectItem>
              ))}
            </ProjectList>
          )}
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ProjectSelectorModal;
